// 该文件定义了各比较符能够进行比较的配置文件

export const Comparisons = [
  // 单值与单值比较
  {
    code: 'AND',
    string: '&&',
    regexp: /^(\&\&)/i
  }, {
    code: 'OR',
    string: '||',
    regexp: /^(\|\|)/i
  },
  {
    code: 'EQUAL',
    string: '==',
    regexp: /^(\=\=)/i
  },
  {
    code: 'NOT-EQUAL',
    string: '!=',
    regexp: /^(\!\=)/i
  },
  {
    code: 'GREAT-THAN-EQUAL',
    string: '>=',
    regexp: /^(\>\=)/i
  },
  {
    code: 'GREAT-THAN',
    string: '>',
    regexp: /^(\>)/i
  },
  {
    code: 'LESS-THAN-EQUAL',
    string: '<=',
    regexp: /^(\<\=)/i
  },
  {
    code: 'LESS-THAN',
    string: '<',
    regexp: /^(\<)/i
  },

  // 判断值是否为Null
  {
    code: 'IS-NOT',
    regexp: /^(IS\s+NOT)(\s+|$)/i
  },
  {
    code: 'IS',
    regexp: /^(IS)(\s+|$)/i
  },

  {
    code: 'NOT-CONTAIN',
    regexp: /^(NOT\s+CONTAIN)(\s+|$)/i
  },
  {
    code: 'CONTAIN',
    regexp: /^(CONTAIN)(\s+|$)/i
  },
  {
    code: 'BEGIN-WITH',
    regexp: /^(BEGIN\s+WITH)(\s+|$)/i
  },
  {
    code: 'END-WITH',
    regexp: /^(END\s+WITH)(\s+|$)/i
  },
  {
    code: 'BETWEEN',
    regexp: /^(BETWEEN)(\s+|$)/i
  },
  {
    code: 'BETWEEN-AND',
    regexp: /^(AND)(\s+|$)/i
  },
  // 单值与数组比较
  {
    code: 'NOT-IN',
    regexp: /^(NOT\s+IN)/i
  },
  {
    code: 'IN',
    regexp: /^(IN)(\s+|$)/i
  },
  {
    code: 'INCLUDE-ANY',
    regexp: /^(INCLUDE\s+ANY)(\s+|$)/i
  },
  // {
  //     code: 'INCLUDE-ALL',
  //     regexp: /^(INCLUDE\s+ALL)(\s+|$)/i
  // },
  // {
  //     code: 'EXCLUDE-ANY',
  //     regexp: /^(EXCLUDE\s+ANY)(\s+|$)/i
  // },
  {
    code: 'EXCLUDE-ALL',
    regexp: /^(EXCLUDE\s+ALL)(\s+|$)/i
  },
  // 数组与单个值比较 ANY --

  {
    code: 'ANY-IS-NOT',
    regexp: /^(ANY\s+IS\s+NOT)(\s+|$)/i
  },
  {
    code: 'ANY-IS',
    regexp: /^(ANY\s+IS)(\s+|$)/i
  },

  {
    code: 'ANY-GREAT-THAN-EQUAL',
    regexp: /^(ANY\s+\>\=)(\s+|$)/i
  },
  {
    code: 'ANY-GREAT-THAN',
    regexp: /^(ANY\s+\>)(\s+|$)/i
  },
  {
    code: 'ANY-LESS-THAN-EQUAL',
    regexp: /^(ANY\s+\<\=)(\s+|$)/i
  },
  {
    code: 'ANY-LESS-THAN',
    regexp: /^(ANY\s+\<)(\s+|$)/i
  },
  {
    code: 'ANY-EQUAL',
    regexp: /^(ANY\s+\=\=)(\s+|$)/i
  },
  {
    code: 'ANY-NOT-EQUAL',
    regexp: /^(ANY\s+\!\=)(\s+|$)/i
  },
  {
    code: 'ANY-BETWEEN',
    regexp: /^(ANY\s+BETWEEN)(\s+|$)/i
  }, // 数组与单个值比较 ALL --

  {
    code: 'ALL-IS-NOT',
    regexp: /^(ALL\s+IS\s+NOT)(\s+|$)/i
  },
  {
    code: 'ALL-IS',
    regexp: /^(ALL\s+IS)(\s+|$)/i
  },
  {
    code: 'ALL-GREAT-THAN-EQUAL',
    regexp: /^(ALL\s+\>\=)(\s+|$)/i
  },
  {
    code: 'ALL-GREAT-THAN',
    regexp: /^(ALL\s+\>)(\s+|$)/i
  },
  {
    code: 'ALL-LESS-THAN-EQUAL',
    regexp: /^(ALL\s+\<\=)(\s+|$)/i
  },
  {
    code: 'ALL-LESS-THAN',
    regexp: /^(ALL\s+\<)(\s+|$)/i
  },
  {
    code: 'ALL-EQUAL',
    regexp: /^(ALL\s+\=\=)(\s+|$)/i
  },
  {
    code: 'ALL-NOT-EQUAL',
    regexp: /^(ALL\s+\!\=)(\s+|$)/i
  },
  {
    code: 'ALL-BETWEEN',
    regexp: /^(ALL\s+BETWEEN)(\s+|$)/i
  },
  // 数组与单个值比较 ALL --
  {
    code: 'ALL-CONTAIN',
    regexp: /^(ALL\s+CONTAIN)(\s+|$)/i
  },
  {
    code: 'ALL-NOT-CONTAIN',
    regexp: /^(ALL\s+NOT\s+CONTAIN)(\s+|$)/i
  },
  {
    code: 'ALL-BEGIN-WITH',
    regexp: /^(ALL\s+BEGIN\s+WITH)(\s+|$)/i
  },
  {
    code: 'ALL-END-WITH',
    regexp: /^(ALL\s+END\s+WITH)(\s+|$)/i
  },
  // 数组与单个值比较 ANY --
  {
    code: 'ANY-CONTAIN',
    regexp: /^(ANY\s+CONTAIN)(\s+|$)/i
  },
  {
    code: 'ANY-NOT-CONTAIN',
    regexp: /^(ANY\s+NOT\s+CONTAIN)(\s+|$)/i
  },
  {
    code: 'ANY-BEGIN-WITH',
    regexp: /^(ANY\s+BEGIN\s+WITH)(\s+|$)/i
  },
  {
    code: 'ANY-END-WITH',
    regexp: /^(ANY\s+END\s+WITH)(\s+|$)/i
  }
];
